export default function AppointmentRequest() {
  return null;
}